import { reportErrorReason } from "../helpers/general-helpers";
var Tags = /** @class */ (function () {
    function Tags() {
        this.id = 'tags';
        this.alias = 'Customer Tags';
    }
    Tags.prototype.getData = function (connector, table, done) {
        connector
            .getApiClient()
            .fetchCustomerTags()
            .then(function (response) { return response.json(); })
            .then(function (data) {
            table.appendRows(data.data.map(function (tag) { return ({
                tag_id: tag.tag_id,
                active: tag.active,
                text: tag.text,
            }); }));
        })
            .then(done)
            .catch(function (reason) { return reportErrorReason(reason, connector.getTableau()); });
    };
    Tags.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: [
                {
                    id: 'tag_id',
                    dataType: 'int',
                    alias: 'Tag ID',
                    description: 'The ID used by Sprout to identify this message tag.',
                },
                {
                    id: 'active',
                    dataType: 'bool',
                    alias: 'Active',
                    description: 'Whether this tag is active (or archived) in Sprout Social.',
                },
                {
                    id: 'text',
                    dataType: 'string',
                    alias: 'Text',
                    description: 'The text of the tag.',
                },
            ],
        };
    };
    return Tags;
}());
export default Tags;
